import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { AvnetEbvV3CredentialsInputDTORuntype, AvnetEbvV3ResponseBodyDTORuntype } from './avnetEbvV3BackendTypes';

export const avnetEbvV3Endpoints = {
    'GET /3rdparty/avnetebvv3/credentials': endpoint({
        description: 'Returns credentials for Avnet EBV V3 integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: AvnetEbvV3ResponseBodyDTORuntype,
    }),
    'POST /3rdparty/avnetebvv3/credentials': endpoint({
        description: 'Uploads credentials for Avnet EBV V3 API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: AvnetEbvV3CredentialsInputDTORuntype,
        responseBody: AvnetEbvV3ResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/avnetebvv3/credentials'],
    }),
    'PATCH /3rdparty/avnetebvv3/credentials': endpoint({
        description: 'Updates credentials for Avnet EBV V3 API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: AvnetEbvV3CredentialsInputDTORuntype,
        responseBody: AvnetEbvV3ResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/avnetebvv3/credentials'],
    }),
    'DELETE /3rdparty/avnetebvv3/credentials': endpoint({
        description: 'Deletes existing credentials for Avnet EBV V3 API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/avnetebvv3/credentials'],
    }),
};
